import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useCallback, useEffect, useState, type FC } from 'react';
import Picker, { type PickerValue } from 'react-mobile-picker';
import type { MobileDatePickerProps } from './types';
import { Text } from '@/components/Typography';
import { ButtonPrimary } from '../ButtonPrimary';
import { formatDate, getDayArray, parseDate } from '@/utility/date';

export const MobileDatePicker: FC<MobileDatePickerProps> = ({
  isOpen,
  onClose,
  value,
  handleChange,
  title
}) => {
  const [formattedValue, setFormattedValue] = useState<PickerValue>();
  const handlePickerChange = useCallback((newValue: PickerValue, key: string) => {
    if (key === 'day') {
      setFormattedValue(newValue)
      return
    }

    const { year, month } = newValue
    const newDayArray = getDayArray(Number(year), Number(month))
    const newDay = newDayArray.includes(newValue.day as string)
      ? newValue.day
      : newDayArray[newDayArray.length - 1]
      setFormattedValue({ ...newValue, day: newDay })
  }, [])

  const handleClose = () => {
    setFormattedValue(parseDate(value === '' ? '1 January 1990' : value));
    onClose();
  }

  const handleChoose = () => {
    if (!formattedValue) return;
    handleChange(formatDate(formattedValue));
    handleClose();
  }

  useEffect(() => {
    setFormattedValue(parseDate(value === '' ? '1 January 1990' : value));
  }, [value]);
  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW="90%">
        {!!title && (
          <ModalHeader>{title}</ModalHeader>
        )}
        <ModalBody
          sx={{
            '& > div > div:last-child': {
              bgColor: 'rgba(244,244,246,0.8)',
              border: 0,
              zIndex: -1,
            }
          }}
        >
          {!!formattedValue && (
            <Picker
              value={formattedValue}
              onChange={handlePickerChange}
              wheelMode="natural"
            >
              <Picker.Column name="day">
                {getDayArray(Number(formattedValue.year), Number(formattedValue.month)).map((day) => (
                  <Picker.Item key={day} value={day}>
                    {({ selected }) => (
                      <Text className={selected ? 'font-semibold text-neutral-900' : 'text-neutral-400'}>
                        {day}
                      </Text>
                    )}
                  </Picker.Item>
                ))}
              </Picker.Column>
              <Picker.Column name="month">
                {Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0')).map((month) => (
                  <Picker.Item key={month} value={month}>
                    {({ selected }) => (
                      <Text className={selected ? 'font-semibold text-neutral-900' : 'text-neutral-400'}>
                        {month}
                      </Text>
                    )}
                  </Picker.Item>
                ))}
              </Picker.Column>
              <Picker.Column name="year">
                {Array.from({ length: 100 }, (_, i) => `${1923 + i}`).map((year) => (
                  <Picker.Item key={year} value={year}>
                    {({ selected }) => (
                      <Text className={selected ? 'font-semibold text-neutral-900' : 'text-neutral-400'}>
                        {year}
                      </Text>
                    )}
                  </Picker.Item>
                ))}
              </Picker.Column>
            </Picker>
          )}
        </ModalBody>
        <ModalFooter>
          <ButtonPrimary w="100%" onClick={handleChoose}>
            Pilih
          </ButtonPrimary>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
